'use strict';


const uiRouter = require('angular-ui-router');

import routes from './viewpoints.routes';

import viewpoints from '../../database/viewpoints.json';
import files from '../../database/files.json';

export class ViewpointsComponent {
  /*@ngInject*/
  constructor($stateParams, $timeout, $state, $scope, $compile, Errors, $localStorage) {
    let $ctrl = this;
    this.$state = $state;
    this.site = $localStorage.site;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.zoomedIn = false;
    this.$compile = $compile;
    this.Errors = Errors;
    this.$localStorage = $localStorage;
    this.highlightenedTrueview = this.site.highlight;
    this.zoomOpts = {
      prefixUrl: '/assets/uploads/',
      tileSources: []
    };
    if(!$localStorage.screen) {
      $localStorage.screen = {
        width: window.screen.width,
        height: window.screen.height
      };
    }

    // number 1503.93 is actually the width of a Trueview in mm.
    // this.zoomFactor = 1503.93 / $localStorage.screen.actualWidth || 4.5;

    //         pixel                    mm
    // Width  Height 	Width   Height  ratio
    // 13146	4550	   1505	    521	      2.89     Old Trueview
    // 14882	5152	   1505	    521	      2.89     New Trueview (V3)
    //  8688	 5792	     879	     586	     1.5       20mm Single Frame

    this.beforeAfterToggle = true;

    this.trueviews = this.extractTrueviewsFromSiteInLocalStorage();

    let viewpoint = viewpoints.find(viewpoint => viewpoint._id == this.$stateParams.id);

    this.zoomFactor = 1503.93 / $localStorage.screen.actualWidth || 4.5;

    $timeout(() => {
      $('.juxtapose-container').css({
        'max-height': '1050px'
      });
    }, 1000);


    $ctrl.trueview = viewpoint;
    $ctrl.trueview.zoomOpts = {
      prefixUrl: `/assets/uploads/${viewpoint.assets.before}/`,
      tileSources: [
        `/assets/uploads/${viewpoint.assets.before}/tiles.dzi.dzi`,
        `/assets/uploads/${viewpoint.assets.after}/tiles.dzi.dzi`
      ],
      constrainDuringPan: true,
      visibilityRatio: 1.0,
      // maxZoomLevel: this.zoomFactor,
      minZoomImageRatio: 1,
      zoomPerClick: 1.0,
      showZoomControl: false,
      showHomeControl: false,
      showFullPageControl: false,
      showRotationControl: false,
      showSequenceControl: false,
      sequenceMode: true,
      preserveViewport: true,
      showNavigator: true,
      navigatorAutoFade: false,
      // navigatorId: 'viewportNavigator',
      navigatorPosition: 'TOP_RIGHT',
      navigatorHeight: '90px',
      navigatorWidth: '250px'
    };

    // hide the leaves and arrow cintrollers on jx slider bar
    $(document).on('mousedown', 'div.jx-handle', () => {
      $('div.jx-handle').on('mousemove', () => {
        $('div.jx-controller, div.jx-arrow').fadeOut(250);
      });
    })
      .mouseup(() => {
        $('div.jx-handle').off('mousemove');
        $('div.jx-controller, div.jx-arrow').fadeIn(250);
      });
  }


  back() {
    this.$window.history.back();
  }

  getImagePath(id) {
    let trueview = files.find(file => file._id === id);
    return `/assets/uploads/${trueview._id}/${trueview.filename}`;
  }


  toggleBeforeAfter($event) {
    $event.preventDefault();
    let $ctrl = this;
    let state = $ctrl.beforeAfterToggle ? 1 : 0;
    let $openSeadragon = $ctrl.$scope.$openSeadragon;
    $openSeadragon.goToPage(state);
  }

  toggleHighlightViewpoints() {
    if(!this.$localStorage.site.highlight) {
      this.trueviews = this.trueviews;
    } else {
      this.trueviews = this.nightTrueviews;
    }
    // let currentViewpoint = this.allTrueviews.find(viewpoint => viewpoint._id == this.$stateParams.id);

    // let otherTrueview = this.allTrueviews.filter(viewpoint => viewpoint._id !== currentViewpoint._id);
    // console.log(otherTrueview);
    console.log(this.trueviews);
    this.switchTrueviewView(this.trueviews[0]._id);
  }

  resetZoom() {
    this.$scope.$openSeadragon.viewport.zoomTo(this.zoomFactor);
  }

  zoom($openSeadragon) {
    // adding trueview zoom tracking, collecting site name as well
    // as the indivisual zoomed trueview name and desc
    let $ctrl = this;
    $openSeadragon = $openSeadragon || $ctrl.$scope.$openSeadragon || false;
    $ctrl.beforeAfterToggle = false;
    $openSeadragon.goToPage(0);
    $openSeadragon.setFullScreen(true);
    window.$openSeadragon = $openSeadragon;


    // TODO: Yuck, need to find a better way than inline templating.
    let fullScreenSwitch = require('./templates/switch.template.html');
    let fullScreenDisclaimer = require('./templates/disclaimer.template.html');
    // We only want to append and bind the toggle button when we go fullscreen and the
    // switch doesn't exist, so we add a handler to attach it if necessary.
    $openSeadragon.addHandler('full-screen', function(event) {
      $ctrl.$timeout(function() {
        $ctrl.resetZoom();
        $openSeadragon.forceRedraw();
      }, 1000);
      if(event.fullScreen) {
        let el = angular.element('.canvas-overlay-box');
        if(el.length <= 0) {
          $('.openseadragon-canvas:first').append($ctrl.$compile(fullScreenSwitch)($ctrl.$scope));
          $('.openseadragon-canvas:first').append($ctrl.$compile(fullScreenDisclaimer)($ctrl.$scope));
        }
      }
    });
  }

  extractTrueviewsFromSiteInLocalStorage = () => {
    let populatedTrueviews = [];
    this.site.viewpoints.forEach(id => {
      var newTV = viewpoints.find(viewpoint => viewpoint._id === id);
      populatedTrueviews.push(newTV);
    });
    return populatedTrueviews;
  }

  switchTrueviewView(id) {
    if(id === this.trueviews._id) {
      return false;
    }
    this.$stateParams.id = id;
    this.$state.go('.');
  }
}

export default angular.module('fplTruescapeComApp.trueviews', [uiRouter])
  .config(routes)
  .component('trueviews', {
    template: require('./viewpoints.html'),
    controller: ViewpointsComponent,
    controllerAs: '$ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/viewpoints/viewpoints.component.js